import React from 'react';
import { useTranslation } from 'react-i18next';
import { formattedFullName } from '../../../../../utils/helpers/CommonHelper.jsx';
import { CellLayout } from '../../../../common/index.jsx';
import ProtectedEmailLink from '../../../../common/ProtectedEmailLink/ProtectedEmailLink.jsx';

export default function DeansOfficeTable({ modelArray, position, note }) {
  const { t } = useTranslation();

  if (
    typeof modelArray === 'undefined' ||
    !modelArray ||
    modelArray.length === 0
  ) {
    return null;
  }

  return (
    <div style={{ marginTop: 20 }}>
      <h3>{position.toUpperCase()}</h3>
      {modelArray.map((item) => (
        <div key={item.employee.person.person_id} className="mt-10px">
          <CellLayout className="workplaces-row">
            <CellLayout.Cell>
              <strong>{formattedFullName(item.employee.person)}</strong>
              &nbsp;&nbsp;
              <ProtectedEmailLink
                user={item.employee.person.mail.split('@')[0]}
                domain={item.employee.person.mail.split('@')[1]}
              />
            </CellLayout.Cell>
          </CellLayout>
          {note && (
            <CellLayout className="workplaces-row">
              <CellLayout.Cell>{note}</CellLayout.Cell>
            </CellLayout>
          )}
          <CellLayout className="workplaces-row">
            <CellLayout.Cell>
              {t('Telefón')}: {item.employee.phone}
            </CellLayout.Cell>
          </CellLayout>
          <CellLayout className="workplaces-row">
            <CellLayout.Cell>
              {t('Miestnosť')}: {item.employee.room}
            </CellLayout.Cell>
          </CellLayout>
        </div>
      ))}
    </div>
  );
}
